import { FormattedMessage } from 'react-intl';
import { useLocation, useParams } from 'react-router';

import { catchAll } from '@sorare/routing';
import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Empty as EmptyCards } from '@sorare/core/src/components/cards/Empty';
import { ANY_SPORT_MY_CARDS_VAULT } from '@sorare/core/src/constants/__generated__/routes';
import { filters } from '@sorare/core/src/lib/glossary';
import { matchAnySportPath } from '@sorare/core/src/lib/routing/generateSportPath';

import { EmptyVaultPlaceholderSealed } from '#src/components/sealing/EmptyVaultPlaceholderSealed/index.tsx';
import { useFiltersCount } from '#src/search/FiltersManager/useFiltersCount.ts';
import type { SearchTopic } from '#src/searchCards/AdvancedCardSearch/types.ts';

import { EmptyMarket } from './EmptyMarket/index.tsx';
import { NoResults } from './NoResults/index.tsx';

type Props = {
  isGallery: boolean;
  topic?: SearchTopic;
};

export const Empty = ({ isGallery, topic }: Props) => {
  const location = useLocation();
  const filtersCount = useFiltersCount({ countSealed: false });
  const isVaultPage = matchAnySportPath(
    catchAll(ANY_SPORT_MY_CARDS_VAULT),
    location.pathname
  );

  const { type } = useParams<{ type?: Rarity }>();

  if (type && isVaultPage) {
    return <EmptyVaultPlaceholderSealed rarity={type} />;
  }

  const title = topic?.label ? (
    <FormattedMessage
      {...filters.noCardsOfTopicFound}
      values={{ topic: topic.label }}
    />
  ) : (
    <FormattedMessage {...filters.noCardsFound} />
  );

  const galleryCTA = isGallery ? null : <EmptyMarket />;
  const description = filtersCount > 0 ? <NoResults /> : galleryCTA;

  return <EmptyCards title={title} description={description} />;
};
